import clsx from "clsx"
import {GatsbyImage, IGatsbyImageData} from "gatsby-plugin-image"
import {useEffect} from "react"
import "./HeroSection.css"

export interface HeroSectionProps extends React.HTMLAttributes<HTMLElement> {
    image: IGatsbyImageData | null | undefined
    mobileImage?: IGatsbyImageData | null | undefined
    gatsbyImageClass?: string | undefined | null
    imageAlt: string | null | undefined
    withMargin?: boolean
    position?: string | undefined
}

const HeroSection: React.FC<HeroSectionProps> = props => {
    const {
        image,
        mobileImage,
        gatsbyImageClass,
        children,
        withMargin = false,
        imageAlt,
        position = "center",
        className,
        ...otherProps
    } = props

    useEffect(() => {
        if (withMargin) {
            const navbar = document.getElementById("nav-bar")
            const hero = document.getElementById("hero")
            if (!navbar || !hero) return
            const navbarHeight = navbar.scrollHeight
            hero.style.marginTop = `${navbarHeight}px`
        }
    }, [])

    return (
        <header className={clsx("hero-d2bh", className)} {...otherProps} id="hero">
            {image && imageAlt && (
                <GatsbyImage
                    alt={imageAlt}
                    image={image}
                    className={clsx(
                        "gatsby-image-d2bh",
                        gatsbyImageClass ? gatsbyImageClass : "",
                        mobileImage ? "gatsby-image-hide-d2bh" : "",
                    )}
                    imgClassName="image-d2bh"
                    loading="eager"
                    objectFit="cover"
                    objectPosition={position}
                />
            )}
            {mobileImage && imageAlt && (
                <GatsbyImage
                    alt={imageAlt}
                    image={mobileImage}
                    className={clsx("gatsby-mobile-image-d2bh", gatsbyImageClass ? gatsbyImageClass : "")}
                    imgClassName="image-d2bh"
                    loading="eager"
                    objectFit="cover"
                    objectPosition={position}
                />
            )}
            {children && <div className="overlay-d2bh">{children}</div>}
        </header>
    )
}

export default HeroSection
